import useSelectWalletBalance from './use-select-wallet-balance';

export default function () {
  return useSelectWalletBalance('renderWallets');
}
